
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    classDiv: String,
    idComponent: String,
    image: String,
    name: String,
    npf: Number,
    cpf: String,
  },
})
export default class ImageProfile extends Vue {}
